<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpBox>
      <ItpText
        muted
        class="mb-0"
      >
        {{ config.resourceTitle }}
      </ItpText>
      <UcPaymentTransactionTypeSymbol
        :transactionType="payment.transaction_type"
        class="mx-2"
        v-if="payment.transaction_type"
      >
      </UcPaymentTransactionTypeSymbol>
    </ItpBox>
    <ItpText
      tag="h4"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <DIV
    class="btn-toolbar ml-auto flex-nowrap"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto mr-2"
      v-if="!isNew"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
    </ItpButton>
    <BtnSyncResource
      :resource="payment"
      target="irent"
      confirmMessage="A tranzakciót csak egyszer lehet felölteni a régi rendszerbe,
feltöltés után a tranzakciót már nem lehet módosítani."
      class="ml-auto mr-2"
      v-if="!isNew"
      @success="evh_4186377094414664_success($event, {})"
    >
    </BtnSyncResource>
    <ItpButton
      variant="light"
      icon="icon-park-outline:preview-open"
      :href="payment.meta.preview_url"
      :tooltip="'Open preview'|pgettext('Payment')"
      target="_blank"
      use-auth
      show-spinner
      class="ml-auto mr-2"
      v-if="payment.meta && payment.meta.preview_url"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        :text="'Complete'|pgettext('Command')"
        :disabled="!isNew && payment.readonly"
        variant="success"
        dropdown-item
        icon="fa-check"
        class="mr-2"
        v-if="!isNew && !payment.isReadonly"
        @click.prevent.stop="evh_1506888955587522_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="payment"
        :tooltip="'Delete payment'|pgettext('Payment')"
        :disabled="payment.isReadonly"
        v-if="!isNew"
        @success="evh_3306541085110264_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcPaymentHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  payment!: object;

  @Watch('payment')
  onPayment(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payment")
  }

  @Prop({
    required: true,
    type: Object,
  })
  config!: object;

  @Watch('config')
  onConfig(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("config")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get isNew() {
    if (this.loaded) {

      return !this.payment.id
    }
    return null;
  }

  get isPettyCash() {
    if (this.loaded) {

      return this.payment.transaction_kind === 'cash_book'
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.isNew ? this.config.newTransaction : this.payment.snapshot('transaction_number')
    }
    return null;
  }

  async act_1040167445267876_emit_7904_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_7904, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_emit_7906_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4186377094414664_emit_7906, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4186377094414664_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_success.executeFromDOM(this, event, scope);
  }

  async act_1506888955587522_setData_7910_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1506888955587522_setData_7910, alias=undefined
    return {
      path: "item",
      value: $event && $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1506888955587522_success_7909_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1506888955587522_success_7909, alias=undefined
    return !!$event.data
  }

  async act_1506888955587522_reloadSlickgrid_7912_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1506888955587522_reloadSlickgrid_7912, alias=undefined
    return {
      grid: "payments",
    }
  }

  async evh_1506888955587522_success_7911_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1506888955587522_success_7911, alias=undefined
    return !!$event.data
  }

  async act_1506888955587522_rest_7908_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1506888955587522_rest_7908, alias=complete
    return {
      method: "save",
      container: {
        self: this.payment.links.parent,
        object: 'list',
        data: []
      },
      resource: this.payment,
      data: {
        etag: this.payment.etag,
        complete: true,
      },
    }
  }

  async act_1506888955587522_rest_7908_getConfirm($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1506888955587522_rest_7908, alias=complete
    return {
      header: this.dialogHeader,
      message: this.$fn.gettext("Completing prevents further modifications. Please confirm this operation."),
      btnOk: this.$fn.gettext("Complete"),
      severity: "warning",
    }
  }

  async evh_1506888955587522_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1506888955587522_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3306541085110264_emit_7914_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3306541085110264_emit_7914, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_3306541085110264_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3306541085110264_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_emit_7904: actions.EmitAction;
    evh_1040167445267876_clickPreventStop_7903: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
    act_4186377094414664_emit_7906: actions.EmitAction;
    evh_4186377094414664_success_7905: actions.EventHandlerImpl;
    evh_4186377094414664_success: actions.EventHandlerGroup;
    act_1506888955587522_setData_7910: actions.SetDataAction;
    evh_1506888955587522_success_7909: actions.EventHandlerImpl;
    act_1506888955587522_reloadSlickgrid_7912: actions.ReloadSlickgridAction;
    evh_1506888955587522_success_7911: actions.EventHandlerImpl;
    act_1506888955587522_rest_7908: actions.RestAction;
    evh_1506888955587522_clickPreventStop_7907: actions.EventHandlerImpl;
    evh_1506888955587522_clickPreventStop: actions.EventHandlerGroup;
    act_3306541085110264_emit_7914: actions.EmitAction;
    evh_3306541085110264_success_7913: actions.EventHandlerImpl;
    evh_3306541085110264_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_emit_7904 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_7904_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_7903 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_7904,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_7903],
      }
    );
    const act_4186377094414664_emit_7906 = new actions.EmitAction(
      {
        actionArgs: this.act_4186377094414664_emit_7906_getActionArgs,
        events: [],
      }
    );
    const evh_4186377094414664_success_7905 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_emit_7906,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_4186377094414664_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_success_7905],
      }
    );
    const act_1506888955587522_setData_7910 = new actions.SetDataAction(
      {
        actionArgs: this.act_1506888955587522_setData_7910_getActionArgs,
        events: [],
      }
    );
    const evh_1506888955587522_success_7909 = new actions.EventHandlerImpl(
      {
        action: act_1506888955587522_setData_7910,
        event: "success",
        when: this.evh_1506888955587522_success_7909_getWhen,
        displayName: "setData",
      }
    );
    const act_1506888955587522_reloadSlickgrid_7912 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1506888955587522_reloadSlickgrid_7912_getActionArgs,
        events: [],
      }
    );
    const evh_1506888955587522_success_7911 = new actions.EventHandlerImpl(
      {
        action: act_1506888955587522_reloadSlickgrid_7912,
        event: "success",
        when: this.evh_1506888955587522_success_7911_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_1506888955587522_rest_7908 = new actions.RestAction(
      {
        actionArgs: this.act_1506888955587522_rest_7908_getActionArgs,
        confirm: this.act_1506888955587522_rest_7908_getConfirm,
        displayName: "complete",
        events: [evh_1506888955587522_success_7909, evh_1506888955587522_success_7911],
      }
    );
    const evh_1506888955587522_clickPreventStop_7907 = new actions.EventHandlerImpl(
      {
        action: act_1506888955587522_rest_7908,
        event: "click.prevent.stop",
        displayName: "complete",
      }
    );
    const evh_1506888955587522_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1506888955587522_clickPreventStop_7907],
      }
    );
    const act_3306541085110264_emit_7914 = new actions.EmitAction(
      {
        actionArgs: this.act_3306541085110264_emit_7914_getActionArgs,
        events: [],
      }
    );
    const evh_3306541085110264_success_7913 = new actions.EventHandlerImpl(
      {
        action: act_3306541085110264_emit_7914,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3306541085110264_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3306541085110264_success_7913],
      }
    );
    return {
      act_1040167445267876_emit_7904,
      evh_1040167445267876_clickPreventStop_7903,
      evh_1040167445267876_clickPreventStop,
      act_4186377094414664_emit_7906,
      evh_4186377094414664_success_7905,
      evh_4186377094414664_success,
      act_1506888955587522_setData_7910,
      evh_1506888955587522_success_7909,
      act_1506888955587522_reloadSlickgrid_7912,
      evh_1506888955587522_success_7911,
      act_1506888955587522_rest_7908,
      evh_1506888955587522_clickPreventStop_7907,
      evh_1506888955587522_clickPreventStop,
      act_3306541085110264_emit_7914,
      evh_3306541085110264_success_7913,
      evh_3306541085110264_success,
      reload: act_1040167445267876_emit_7904,
      complete: act_1506888955587522_rest_7908,
    }
  }
}

Vue.component("UcPaymentHeader", UcPaymentHeader);

</script>